import { render } from "./Avantage.vue?vue&type=template&id=1b82eac4"
import script from "./Avantage.vue?vue&type=script&lang=js"
export * from "./Avantage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__